import { useState } from 'react';

import accessUtils from '../utils/accessUtils';

import { USER_ONBOARDING_DISMISSED_KEY } from '../constants/UserOnboardingConstants';

import { useAuth } from '../components/AuthProvider';

import type { ComponentProps } from 'react';
import type UserOnboarding from '../components/modals/UserOnboarding';

type UserOnboardingProps = ComponentProps<typeof UserOnboarding>;

export const usePropertiesPageUserOnboarding = ({ numTotalListings }: { numTotalListings: number }) => {
  const { user } = useAuth();

  const canAccessUserOnboardingNewUserFlag = accessUtils.canAccessUserOnboardingNewUser({
    user,
  });
  const canAccessUserOnboardingExistingUser = accessUtils.canAccessUserOnboardingExistingUser({
    user,
  });

  const [isVewingUserOnboardingNewUser, setIsViewingUserOnboardingNewUser] = useState(
    canAccessUserOnboardingNewUserFlag,
  );
  const [showUserOnboardingExistingUser, setShowingUserOnboardingExisitngUser] = useState(false);

  const canAccessUserOnboardingNewUser = Boolean(canAccessUserOnboardingNewUserFlag && isVewingUserOnboardingNewUser);

  let onboardingConfig: UserOnboardingProps | null = null;
  if (canAccessUserOnboardingNewUserFlag && isVewingUserOnboardingNewUser) {
    onboardingConfig = {
      onClose: () => setIsViewingUserOnboardingNewUser(false),
      size: 'fullScreen',
      isNewUser: true,
    };
  } else if (showUserOnboardingExistingUser) {
    onboardingConfig = {
      onClose: () => {
        if (typeof window !== 'undefined') {
          sessionStorage.setItem(USER_ONBOARDING_DISMISSED_KEY, 'true');
        }
        setShowingUserOnboardingExisitngUser(false);
      },
      size: { base: 'fullScreen', md: 'sm' },
      isNewUser: numTotalListings === 0,
    };
  }

  return {
    canAccessUserOnboardingNewUser,
    setShowingUserOnboardingExisitngUser,
    canAccessUserOnboardingExistingUser,
    onboardingConfig,
  };
};
